import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDrawer3"><Path d="M2.5 4.5H21.5V18.5H2.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 4.5V18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 18.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 18.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 9.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 9.5V12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDrawer3;
